const cards = [
  { num: '01', title: 'CODE', desc: 'Clean architecture.\nBuilt to endure.' },
  { num: '02', title: 'SYSTEMS', desc: 'Built to survive\npressure at scale.' },
  { num: '03', title: 'EXPERIENCE', desc: 'Interfaces people\nfeel, not just use.' },
  { num: '04', title: 'SCALE', desc: 'Ready for growth.\nBuilt to last.' },
];

export default function WhatWeBuild() {
  return (
    <section className="section section--divider" id="services">
      <div className="section__label">04 — WHAT WE BUILD</div>

      <h2 className="section__headline">
        WE BUILD<br />WHAT MATTERS.
      </h2>

      <div className="build__grid">
        {cards.map((card) => (
          <div className="build__card" key={card.num}>
            <div className="build__card-num">{card.num}</div>
            <div className="build__card-title">{card.title}</div>
            <div className="build__card-desc" style={{ whiteSpace: 'pre-line' }}>
              {card.desc}
            </div>
            <div className="build__card-accent" />
          </div>
        ))}
      </div>
    </section>
  );
}
